import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Collapse,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  Edit,
  Delete,
} from '@material-ui/icons/';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { withRouter } from "react-router";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import MuiAlert from "@material-ui/lab/Alert";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    // overflow: "auto",
    flexDirection: "column",
  },
  table: {
    // width: "1600px",
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  idCell: {
    width: "75px",
  },
  nameCell: {
    width: "200px",
  },
  emailCell: {
    width: "250px",
  },
  outlineCell: {
    width: "200px",
  },
  iconCell: {
    width: "130px",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  dateCol: {
    width: "105px",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  
}));

function Users(props) {
  const { request } = useApi();
  const { state } = useAuth();
  const auth = useAuth();
  const classes = useStyles();

  const [users, setUsers] = React.useState([]);
  const [features, setFeatures] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [success, setSuccess] = React.useState(null);
  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - 管理者管理";

    if (props.location.search.indexOf("create") > -1) {
      setSuccess("create");
    }
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess("edit");
    }
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchData();
  }, [auth.state.token]);

  const openDialog = (id) => {
    setDeleteId(id);
    setIsShowModal(true);
  };

  const fetchData = () => {
    request({
      method: "GET",
      url: `/admin/users`,
    }).then((result) => {
      setUsers(result.data.data);
    });

    request({
      method: "GET",
      url: `/admin/features`,
    }).then((result) => {
      setFeatures(result.data.data);
    });
  };

  // 権限をIDから権限名に置換
  function replaceFeatures(data) {
    if (features.length === 0) {
      return;
    }
    let useFeatures = [];
    data.map((featureId) => {
      const feature = features.find(({id}) => id == featureId);
      useFeatures.push(feature.name);
    })
    return useFeatures.join(" / ");
  }

  const onClickEditButton = (id) => {
    props.history.push(`/admin/administrator/edit/${id}`);
  };

  const deleteUser = () => {
    request({
      method: "DELETE",
      url: `admin/users/${deleteId}`,
    }).then(() => {
      fetchData();
      setIsShowModal(false);
    });
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
    const [open, setOpen] = React.useState(false);
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell>{row.id}</TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell>{row.desc ? row.desc : "-"}</TableCell>
          <TableCell>{row.email}</TableCell>
          <TableCell>{dayjs(row.created).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
          <TableCell>{dayjs(row.updated).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
          <TableCell>
            <IconButton 
              color="primary" 
              aria-label="add an Edit"
              disabled={row.id === 1}
              onClick={() => onClickEditButton(row.id)}
            >
              <Edit />
            </IconButton>
            <IconButton 
              className={classes.buttonRed} 
              aria-label="add an Delete"
              disabled={row.desc === "ビルトイン"}
              onClick={() => openDialog(row.id)}
            >
              <Delete />
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div">
                  権限設定
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>利用可能機能</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{replaceFeatures(row.features)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                管理者一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell className={classes.idCell}>ID</TableCell>
                    <TableCell className={classes.nameCell}>名前</TableCell>
                    <TableCell className={classes.outlineCell}>概要</TableCell>
                    <TableCell className={classes.emailCell}>メールアドレス</TableCell>
                    <TableCell>作成日</TableCell>
                    <TableCell>更新日</TableCell>
                    <TableCell className={classes.iconCell}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map(
                    function (row, index) {
                      return <Row key={index} index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            {success && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {success === "edit" ? "更新" : "登録"}が完了しました
              </MuiAlert>
            )}
            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => props.history.push(`/admin/administrator/create`)}
              >
                管理者登録
              </Button>
            </Grid>
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={deleteUser}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(Users);
